import * as React from 'react'

import { Box, Row, Skeleton } from '@factorialco/deprecated-design-system'

import Page from 'modules/layout/components/Page'

const Title = () => {
  return (
    <Box
      justifyContent="center"
      alignItems="center"
      padding="s16"
      minHeight="s64"
      style={{
        boxShadow: 'inset 0px -1px 0px rgb(0 0 0 / 10%)',
      }}
    >
      <Box justifyContent="center" alignItems="center" width="full">
        <Skeleton width="s200" height="s16" />
      </Box>
    </Box>
  )
}

const Icon = () => {
  return <Skeleton width="s32" height="s32" />
}

const SectionTitle = () => {
  return <Skeleton width="full" height="s24" />
}

const SectionDescription = () => {
  return (
    <Box gap="s8">
      <Skeleton width="full" height="s16" />
      <Skeleton width="s240" height="s16" />
    </Box>
  )
}

const Content = () => {
  return (
    <Box flexGrow width="full" paddingX="s64" paddingY="s32">
      <Row>
        <Row.Col halfWidth>
          <Box gap="s16" paddingRight="s64" maxWidth="s400">
            <Icon />
            <SectionTitle />
            <SectionDescription />
          </Box>
        </Row.Col>
        <Row.Col halfWidth>
          <Box gap="s24">
            <Skeleton width="full" height="s48" />
            <Skeleton width="full" height="s48" />
            <Skeleton width="full" height="s140" />
          </Box>
        </Row.Col>
      </Row>
    </Box>
  )
}

const SkeletonLoader = () => {
  return (
    <Page>
      <Page.Header>
        <Title />
      </Page.Header>
      <Page.Body size="wide">
        <Content />
        <Content />
        <Content />
      </Page.Body>
    </Page>
  )
}

export default SkeletonLoader
